import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/jadwal-imsak/$kota")({
  component: () => <Outlet />,
});